<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    
    <template v-if="!item.children || item.hiddenChild">
      <el-menu-item :index="resolvePath(item.path)">
        <router-link  :to="resolvePath(item.path)">{{ item.meta.title }}</router-link>
      </el-menu-item>
    </template>
    <!--  :popper-append-to-body="false" -->
   
    <el-submenu v-else  class="errr" popper-class='submenu'  :index="resolvePath(item.path)"  popper-append-to-body>
      
      <template slot="title">
        <span>{{ item.meta.title }}</span>
      </template>
     
      <div class="subFlexMenu">
        <div class="subBg"></div>
        <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" />
      </div>
      <!-- <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" /> -->
    </el-submenu>
    
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
// import Item from './Item'
// import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  // components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
  },
  data () {
    return {}
  },
  methods: {
    resolvePath (routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        // return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style lang="scss" >
.el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
  min-width: 1.1rem !important;
}
.el-menu--horizontal.submenu{
  height: 200px;
  overflow: hidden;
}
.subBg{
  // content: '';
  position: fixed !important;
  top: 59px;
  left: 0 !important;
  width: 100vw; /* 设置二级菜单宽度为整个视口宽度 */
  background: #fff;
  height: 200px;
}
.subFlexMenu {
  width: 365px;
  padding: 10px auto 0;
  display: flex;
  flex-wrap: wrap;
  box-shadow: none;
  transition: opacity 0.5s ease-in-out;
  .menu-wrapper.nest-menu{
    width: 50%;
    overflow: hidden;
    .el-menu-item:focus, .el-menu-item:hover{
      // background: #fff !important;
      a:hover{
        color: #3488FA !important;
      }
    }
  }
}
.subFlexMenu:hover .menu-wrapper.nest-menu{
  display: block;
}
</style>

<style lang='scss' scoped>

.menu-wrapper{
  display:inline-block;
  margin:0 0.2rem;

  .submenu{

    ul{
      width:auto;
    }
  }
  
  :deep(.errr.el-submenu:hover),:deep(.el-submenu__title:focus),:deep( .el-submenu__title:hover){
    height: 100% !important;
    background-color:#3488FA !important;
    border-radius:10px;
    color: #fff ;
  }
  :deep(.errr.el-submenu),:deep( .el-submenu__title){
    height: 100% !important;
    line-height: 2.2 !important;
    font-size: 16px !important;
    color: #000;
    padding: 0 !important;
    display: flex;
    justify-content: center;
    span{
      padding: 0 10px;
    }
    .el-submenu__icon-arrow{
      display: none;
    }
  } 
}
.itemTitle{
  font-size:16px;
}
.nest-menu{
  display:block;
  margin:0;
}

.nest-menu a{
  font-size:0.18rem;
  display:inline-block;
  width:100%;
  height:100%;
}
.nest-menu:hover{
  a{
    color:#105fa8;
  }
}
.nest-menu .is-active a{
  color: #105fa8;
  // border-bottom:6px solid #105fa8;
}
</style>
